import { cn } from '@/utils';
import { CSSProperties, memo, useCallback, useRef, useState } from 'react';
import SignatureCanvas, {
	ReactSignatureCanvasProps,
} from 'react-signature-canvas';

import ModalSignature from './modalSignature.view';

export type SignatureData = {
	name: string;
	imgData: string;
};

export type SignatureProps = {
	name: string;
	className?: string;
	dataUrl: string;
	onSubmit?: (data: SignatureData) => void;
	style?: CSSProperties | undefined;
	signatureCanvasProps?: ReactSignatureCanvasProps;
};

const Signature = ({
	name,
	className,
	dataUrl,
	onSubmit,
	style,
	signatureCanvasProps = {},
}: SignatureProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const refCanvas = useRef<SignatureCanvas>(null);

	const toggleSignature = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	const _onSubmit = useCallback(() => {
		const imgData = refCanvas.current
			?.getTrimmedCanvas()
			.toDataURL('image/png');

		onSubmit?.({
			name,
			imgData: imgData || '',
		});
		setIsOpen(false);
	}, [onSubmit, name]);

	return (
		<div className={cn('absolute', className)} style={style}>
			{dataUrl && (
				<div
					className="w-full h-full bg-no-repeat bg-center bg-contain"
					style={{
						backgroundImage: `url("${dataUrl}")`,
					}}
				></div>
			)}
			<div
				className="absolute w-full h-full top-0 left-0 z-10 bg-transparent cursor-pointer"
				onClick={toggleSignature}
			/>

			<ModalSignature
				open={isOpen}
				onCancel={toggleSignature}
				onSubmit={_onSubmit}
				refCanvas={refCanvas}
				signatureCanvasProps={signatureCanvasProps}
			/>
		</div>
	);
};

export default memo(Signature);
